import React, { useState } from 'react';
import styled from 'styled-components';
import {
  minBreakpointQuery,
  brandColours,
  fluidFontSize,
  breakpointSizes,
  fontSize,
} from '../utilities';

const Accordion = styled.div`
  background: ${brandColours.senary};
`;

const Plus = styled.span`
  position: relative;
  height: 22px;
  min-width: 22px;
  display: block;
  margin-left: 20px;
  &:before,
  &:after {
    content: '';
    position: absolute;
    background: ${brandColours.primary};
  }

  &:before {
    height: 2px;
    width: 100%;
    top: 50%;
    transform: translateY(-50%);
  }

  &:after {
    height: 100%;
    width: 2px;
    left: 50%;
    transform: translateX(-50%);
    ${props =>
      props.active &&
      `
      opacity: 0;
    `}
  }
`;

const UpperAccordion = styled.div`
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 30px 20px;
  cursor: pointer;
  ${minBreakpointQuery.large`
    padding-left: 35px;
    padding-right: 35px;
  `}
`;

const LowerAccordion = styled.div`
  padding: 0 20px 35px;
  ${minBreakpointQuery.large`
    padding-left: 35px;
    padding-right: 35px;
  `}
`;

const Heading = styled.h4`
  ${fluidFontSize('16px', '18px', breakpointSizes.tiny, breakpointSizes.large)};
  font-weight: 700;
`;

const Text = styled.p`
  ${fontSize(16)};
  line-height: 1.6;
  white-space: break-spaces;
`;

export default ({ heading, text }) => {
  const [active, setActive] = useState(false);

  return (
    <Accordion>
      <UpperAccordion onClick={() => setActive(!active)}>
        <Heading>{heading}</Heading>
        <Plus active={active} />
      </UpperAccordion>
      {active && (
        <LowerAccordion>
          <Text>{text}</Text>
        </LowerAccordion>
      )}
    </Accordion>
  );
};
